export const BASE_EVENT_STATUS = {
  DRAFT: {
    key: 'DRAFT',
    value: 'Draft',
  },
  UPDATED: {
    key: 'UPDATED',
    value: 'Updated',
  },
  READY_FOR_APPROVAL: {
    key: 'READY_FOR_APPROVAL',
    value: 'Ready For Approval',
  },
  PUBLISHED: {
    key: 'PUBLISHED',
    value: 'Published',
  },
  INTERNAL: {
    key: 'INTERNAL',
    value: 'Internal',
  },
};
export const BASE_EVENT_DISTRIBUTION = {
  MANAGER: {
    key: 'MANAGER',
    value: 'Managerial',
  },
  INTERNAL: {
    key: 'INTERNAL',
    value: 'Internal',
  },
  CLIENT_ALL: {
    key: 'CLIENT_ALL',
    value: 'Business Clients',
  },
  PUBLIC: {
    key: 'PUBLIC',
    value: 'All Personnel & Customers',
  },
};

export const BASE_INCIDENT_STATUS = {
  FUTURE_EVENT: {
    key: 'FUTURE_EVENT',
    value: 'Upcoming',
  },
  CURRENT_EVENT: {
    key: 'CURRENT_EVENT',
    value: 'In-Progress',
  },
  COMPLETED_EVENT: {
    key: 'COMPLETED_EVENT',
    value: 'Complete',
  },
};

export const EVENT_INCIDENT_STATUS = [
  {
    id: BASE_INCIDENT_STATUS.FUTURE_EVENT.key,
    name: BASE_INCIDENT_STATUS.FUTURE_EVENT.value,
  },
  {
    id: BASE_INCIDENT_STATUS.CURRENT_EVENT.key,
    name: BASE_INCIDENT_STATUS.CURRENT_EVENT.value,
  },
  {
    id: BASE_INCIDENT_STATUS.COMPLETED_EVENT.key,
    name: BASE_INCIDENT_STATUS.COMPLETED_EVENT.value,
  },
];

export const eventStatusFilterOption = [
  { id: BASE_EVENT_STATUS.DRAFT.key, name: BASE_EVENT_STATUS.DRAFT.value },
  { id: BASE_EVENT_STATUS.UPDATED.key, name: BASE_EVENT_STATUS.UPDATED.value },
  {
    id: BASE_EVENT_STATUS.READY_FOR_APPROVAL.key,
    name: BASE_EVENT_STATUS.READY_FOR_APPROVAL.value,
  },
  {
    id: BASE_EVENT_STATUS.PUBLISHED.key,
    name: BASE_EVENT_STATUS.PUBLISHED.value,
  },
];
export const eventStatusId = {
  DRAFT: BASE_EVENT_STATUS.DRAFT.key,
  UPDATED: BASE_EVENT_STATUS.UPDATED.key,
  READY_FOR_APPROVAL: BASE_EVENT_STATUS.READY_FOR_APPROVAL.key,
  PUBLISHED: BASE_EVENT_STATUS.PUBLISHED.key,
  INTERNAL: BASE_EVENT_STATUS.INTERNAL.key,
};
export const eventStatusValue = {
  DRAFT: BASE_EVENT_STATUS.DRAFT.value,
  UPDATED: BASE_EVENT_STATUS.UPDATED.value,
  READY_FOR_APPROVAL: BASE_EVENT_STATUS.READY_FOR_APPROVAL.value,
  PUBLISHED: BASE_EVENT_STATUS.PUBLISHED.value,
  INTERNAL: BASE_EVENT_STATUS.INTERNAL.value,
};
export const eventDistributionId = [
  BASE_EVENT_DISTRIBUTION.MANAGER.key,
  BASE_EVENT_DISTRIBUTION.INTERNAL.key,
  BASE_EVENT_DISTRIBUTION.CLIENT_ALL.key,
  BASE_EVENT_DISTRIBUTION.PUBLIC.key,
];
export const eventDistributionValue = [
  BASE_EVENT_DISTRIBUTION.MANAGER.value,
  BASE_EVENT_DISTRIBUTION.INTERNAL.value,
  BASE_EVENT_DISTRIBUTION.CLIENT_ALL.value,
  BASE_EVENT_DISTRIBUTION.PUBLIC.value,
];

export const eventPublicDistribution = [
  {
    id: BASE_EVENT_DISTRIBUTION.PUBLIC.key,
    label: BASE_EVENT_DISTRIBUTION.PUBLIC.value,
  },
];

export const eventDistributionOptions = [
  {
    id: BASE_EVENT_DISTRIBUTION.MANAGER.key,
    label: BASE_EVENT_DISTRIBUTION.MANAGER.value,
  },
  {
    id: BASE_EVENT_DISTRIBUTION.INTERNAL.key,
    label: BASE_EVENT_DISTRIBUTION.INTERNAL.value,
  },
  {
    id: BASE_EVENT_DISTRIBUTION.CLIENT_ALL.key,
    label: BASE_EVENT_DISTRIBUTION.CLIENT_ALL.value,
  },
];

export const eventDistributionOptionsForSupervisor = [
  {
    id: BASE_EVENT_DISTRIBUTION.MANAGER.key,
    label: BASE_EVENT_DISTRIBUTION.MANAGER.value,
  },
  {
    id: BASE_EVENT_DISTRIBUTION.INTERNAL.key,
    label: BASE_EVENT_DISTRIBUTION.INTERNAL.value,
  },
];

export const EventPlaceholder = {
  title: 'Enter the title of the event.',
  repFirstName: "Enter reporter's first name",
  repLastName: "Enter reporter's last name",
  jobRole: 'Enter the job the person performs.  e.g Guard, Accountant',
  companyName: 'Enter company name.',
  public:
    'Enter the description for the public to see. They will only see this when the event is distributed and published.',
  client:
    'Enter the description for your business clients to see. They will only see this when the event is distributed, published and they are an involved company.',
  internal: 'Enter the description for your internal use.',
  //whoHappened: 'Enter the description for who was involved in the incident',
  severity: 'Enter the severity description',
};
export const eventDistributionOptionsForFilter = [
  {
    id: BASE_EVENT_DISTRIBUTION.MANAGER.key,
    name: BASE_EVENT_DISTRIBUTION.MANAGER.value,
  },
  {
    id: BASE_EVENT_DISTRIBUTION.INTERNAL.key,
    name: BASE_EVENT_DISTRIBUTION.INTERNAL.value,
  },
  {
    id: BASE_EVENT_DISTRIBUTION.CLIENT_ALL.key,
    name: BASE_EVENT_DISTRIBUTION.CLIENT_ALL.value,
  },
  {
    id: BASE_EVENT_DISTRIBUTION.PUBLIC.key,
    name: BASE_EVENT_DISTRIBUTION.PUBLIC.value,
  },
];

export const EventFollowupButtons = {
  eventButtonText: 'Add new followup report',
  taskButtonText: 'Add new followup task',
};

export const eventsNewsFeed = {
  title: 'My Events',
};
